import React, { Component } from 'react'
import { connect } from 'react-redux'
import { isEmpty } from 'ramda'
import { Div, H2, H6 } from '@driftt/tide-core'
import { Icon } from '@driftt/tide-icons'
import { EmptyState } from '@driftt/crm-components'
import List from './List'

const mapStateToProps = state => ({
  playbookEvents: state.__CRM.filterBuilder.playbookEvents,
  playbook: state.__CRM.filterBuilder.playbook
})

class PlaybookEventList extends Component {
  constructor(props) {
    super(props)

    this.state = {
      events: null,
      firstLoad: true
    }
  }

  componentDidMount() {
    this.formatData()
  }

  formatData = () => {
    const { playbookEvents } = this.props

    this.setState({
      firstLoad: false,
      events: [{
        title: 'Event',
        properties: playbookEvents
      }]
    })
  }

  render() {
    const { onSelectProp, playbook, playbookEvents, onBackNavigation } = this.props
    const { events, firstLoad } = this.state
    
    return (
      <Div className="filter-builder--playbook-events">
        <Div className="filter-builder--playbook-events--header">
          <Div className="filter-builder--back-button" onClick={() => onBackNavigation(false)}>
            <Icon name="arrow-1-left" height={10} />
            Back
          </Div>
          <H6>Filter Playbook Event</H6>
          <H2>
            {!!playbook && playbook.name}
          </H2>
        </Div>
        {(!!events && !isEmpty(playbookEvents)) && 
          <List 
            displayKey="label" 
            filterKey="name" 
            onSelect={onSelectProp} 
            helpText={'Tags are labels added to a contact'}
            title={'Contact Tags'}
            properties={events}
            hideType={true}
            subEntityType={'playbookEvents'}
          />
        }
        {(isEmpty(playbookEvents) && !firstLoad) &&
          <Div className="filter-builder--playbook-events--empty">
            <EmptyState topText={''} bottomText={'This playbook does not have any events associated with it.'} />
          </Div>
        }
      </Div>
    )
  }
}

export default connect(mapStateToProps)(PlaybookEventList)
